import { defineMessages } from "react-intl";

export default defineMessages({
    totalCost: {
        id: "components.specification.dataTableTotal.totalCost",
        defaultMessage: "Total Cost", // Gesamtkosten
    },
});
